<ng-template #urlsMenu let-urls="urls">
	<reach-menu cdkMenu class="p-1 rounded-1.5 w-27">
		<div
			class="gap-0.25 w-full flex scrollbar-fade overflow-auto flex-col items-center max-h-40"
		>
			@for (url of urls; track $index) {
				<a
					[title]="url"
					[href]="url"
					target="_blank"
					class="py-0.5 px-1 rounded-0.75 gap-1 w-full flex items-center hover:bg-standard-hover"
				>
					<i class="icon-www-url text-sp-2 node-website node-type-color"></i>
					<span class="text-sp-1.75 truncate leading-2.5">
						{{ url }}
					</span>
				</a>
			}
		</div>
	</reach-menu>
</ng-template>

<ng-template
	#sourceCardTpl
	let-item="item"
	let-expanded="expanded"
	let-withBg="withBg"
	let-canToggle="canToggle"
	let-inBottomMenu="inBottomMenu"
	let-selected="selected"
>
	<div
		[attr.role]="expanded ? 'button' : null"
		class="p-1 flex rounded-1.5 gap-1.5 w-full flex-col items-start justify-start"
		[class.hover:bg-standard-hover]="canToggle || !expanded"
		[class.bg-190]="!withBg"
		[class.bg-280]="withBg"
		[style.cursor]="expanded && !canToggle ? null : 'pointer'"
		[style.max-height]="$smallScreen() && expanded ? '50%' : null"
		(click)="canToggle ? toggleSmallScreen() : openNode(item.node.id)"
	>
		<div class="gap-1.5 w-full flex items-center justify-start">
			<!-- NODE -->
			<common-node-thumbnail [node]="item.node" class="flex-none w-5 h-5">
				<!-- NODE IMG -->
			</common-node-thumbnail>

			<div class="flex-auto gap-0.5 truncate flex flex-col items-start justify-start">
				<p
					#nodeNameElement
					class="truncate w-full fc-800"
					[tooltip]="$showNameTooltip() ? item.node.name : null"
					(mouseover)="updateNameTooltip(nodeNameElement)"
				>
					{{ item.node.name }}
				</p>
				<div class="gap-0.5 flex items-center">
					@if (item.certified) {
						<i class="icon-bold-verified-check text-sp-1.5 text-primary"></i>
					} @else {
						<i class="flex-none text-sp-1.5" [nodeTypeIcon]="item.node.nodeType"></i>
					}
					<span class="text-sp-1.5 fc-400">{{ item.creationFileDate }}</span>
				</div>
			</div>

			@if (inBottomMenu) {
				<i
					class="flex-none"
					[class.icon-bold-tick-circle]="selected"
					[class.text-primary]="selected"
					[class.icon-chevron]="!selected"
					[class.chevron-right]="!selected"
					[class.fc-400]="!selected"
				></i>
			} @else {
				<i
					class="flex-none fc-400 icon-chevron"
					[class.chevron-up]="expanded"
					[class.chevron-down]="!expanded"
				></i>
			}
		</div>

		@if (canToggle || expanded) {
			<div class="gap-1 w-full flex items-center justify-start">
				@if (configuration.canNavigateToNode) {
					<!-- ACTIONS -->
					@if (canOpenNodeCurrentClient) {
						<a
							title="Go to node"
							commonButtonFilled
							[routerLink]="['/', 'home', 'node', item.node.id]"
							size="XS"
							class="flex-auto truncate justify-center group/source-preview-modal w-[calc((100%-8px)*0.5)] bg-170"
							(click)="closeModal()"
						>
							<i
								class="icon-unassigned-nodes-no-relationships text-icon-s group-hover/source-preview-modal:text-primary"
							></i>
							<span class="truncate">Go to node</span>
						</a>
					} @else {
						<a
							commonButtonFilled
							[href]="['home', 'node', item.node.id] | mainClientUrl"
							target="_blank"
							size="XS"
							class="flex-auto truncate justify-center group/source-preview-modal w-[calc((100%-8px)*0.5)] bg-170"
						>
							<i
								class="icon-knowledge-network text-icon-s group-hover/source-preview-modal:text-primary"
							></i>
							<span class="truncate">Go to node</span>
						</a>
					}
					<!--  -->
				}
				<!--  -->
				@if (item.node | nodeAsFile; as file) {
					@if (customDownloadLogic) {
						<div
							title="Download"
							[attr.role]="'button'"
							commonButtonFilled
							size="XS"
							class="flex-auto truncate justify-center group/source-preview-modal w-[calc((100%-8px)*0.5)] cursor-pointer bg-170"
							(click)="$event.stopPropagation(); customDownload(file)"
						>
							<i
								class="flex-none text-icon-s group-hover/source-preview-modal:text-primary icon-download"
							></i>
							<span class="truncate">Download</span>
						</div>
					} @else if (!!showDownloadButton()) {
						<a
							title="Download"
							commonButtonFilled
							[href]="fileUrl(file)"
							target="_blank"
							download
							size="XS"
							class="flex-auto truncate justify-center group/source-preview-modal w-[calc((100%-8px)*0.5)] bg-170"
						>
							<i
								class="flex-none text-icon-s group-hover/source-preview-modal:text-primary icon-download"
							></i>
							<span class="truncate">Download</span>
						</a>
					}
					@if (file.data.websitesToOpen; as fileWebsiteUrls) {
						@if (fileWebsiteUrls.length === 1) {
							<a
								title="Visit Website"
								commonButtonFilled
								[href]="fileWebsiteUrls[0]"
								target="_blank"
								size="XS"
								class="flex-auto truncate justify-center group/source-preview-modal w-[calc((100%-8px)*0.5)] bg-170"
							>
								<i
									class="flex-none text-icon-s group-hover/source-preview-modal:text-primary icon-open-website"
								></i>
								<span class="truncate">Visit Website</span>
							</a>
						} @else {
							<div
								title="Visit Websites"
								#menusBtn="cdkMenuTriggerFor"
								[cdkMenuTriggerFor]="urlsMenu"
								[cdkMenuTriggerData]="{ urls: fileWebsiteUrls }"
								commonButtonFilled
								size="XS"
								class="flex-auto truncate cursor-pointer justify-center group/source-preview-modal w-[calc((100%-8px)*0.5)] bg-170"
							>
								<i
									class="flex-none text-icon-s group-hover/source-preview-modal:text-primary icon-open-website"
								></i>
								<span class="truncate">Visit Websites</span>
							</div>
						}
					}
					<!--  -->
				}
				@if (item.node | nodeAsWebsite; as website) {
					<a
						title="Visit Website"
						commonButtonFilled
						[href]="website.data.url"
						target="_blank"
						size="XS"
						class="flex-auto truncate justify-center group/source-preview-modal w-[calc((100%-8px)*0.5)] bg-170"
					>
						<i
							class="flex-none text-icon-s group-hover/source-preview-modal:text-primary icon-open-website"
						></i>
						<span class="truncate">Visit website</span>
					</a>
				}
			</div>
		}
		<!--  -->
		@if (expanded) {
			<div
				class="py-1 px-0.5 gap-1.5 w-full flex flex-col items-start justify-start"
				[style.overflow-y]="$smallScreen() && expanded ? 'scroll' : null"
			>
				@for (source of item.sources; track source.id) {
					<!-- SOURCE -->
					<button
						class="gap-1 w-full flex items-start justify-start group/source-preview-modal"
						(click)="$event.stopPropagation(); selectSource(source)"
					>
						<div
							class="rounded-circle flex-none text-xs overflow-hidden flex fc-white items-center justify-center w-2 h-2 bg-line-330"
						>
							<div
								class="w-full h-full flex items-center justify-center group-hover/source-preview-modal:bg-primary"
							>
								{{ source.inlineNumber }}
							</div>
						</div>
						<p
							class="flex-auto leading-(--l-h) overflow-hidden max-h-[calc(var(--l-h)*2)] [--l-h:var(--fs-l)] [display:-webkit-box] [line-clamp:2] [-webkit-box-orient:vertical]"
						>
							@if (item.previewType === SourcePreviewType.PDF) {
								<span class="fc-400">
									<span class="group-hover/source-preview-modal:text-primary">
										Pg.{{ source.data.boundingBox.page }}&nbsp;-&nbsp;
									</span>
								</span>
							}

							<span class="text-sp-1.5 fc-800 break-all">
								{{ source.content }}
							</span>
						</p>
					</button>
				}
			</div>
		}
	</div>
</ng-template>

<div
	class="w-full h-full flex relative justify-center backdrop-scrim [--spacing:8px]"
	[class.items-center]="!$smallScreen()"
	[class.items-end]="$smallScreen()"
	(click)="closeModal()"
>
	<div
		class="gap-0.5 overflow-hidden flex bg-190 shadow-z-menu flex-col items-start justify-start"
		[class]="$modalBoxClass()"
		[class.pb-safe-b]="$smallScreen()"
		(click)="$event.stopPropagation()"
	>
		<div class="py-1.5 px-2 flex-none gap-1 w-full flex items-center justify-start">
			@if ($smallScreen()) {
				<button commonButtonIcon (click)="toggleShowingAllSourcesMenu()">
					<i class="icon-text-editor-bullet-list"></i>
				</button>
			} @else {
				<div commonButtonIcon class="invisible">
					<i class="icon-cross-close"></i>
				</div>
			}

			<p
				class="flex-auto truncate font-bold text-center"
				[class]="!$isDesktop() ? 'text-sp-2.25' : ''"
				[class.text-h5]="$isDesktop()"
			>
				Answer Sources
			</p>

			<button commonButtonIcon (click)="closeModal()">
				<i class="icon-cross-close"></i>
			</button>
		</div>

		<div
			class="px-1 pb-2 flex-auto gap-1 overflow-hidden flex w-full items-start justify-start"
			[class.flex-col]="$smallScreen()"
		>
			@if ($smallScreen()) {
				<!--  -->
				@if ($selectedItem(); as selected) {
					<ng-container
						[ngTemplateOutlet]="sourceCardTpl"
						[ngTemplateOutletContext]="{
							item: selected,
							expanded: $smallCardExpanded(),
							withBg: true,
							canToggle: true,
							inBottomMenu: false,
							selected: false,
						}"
					></ng-container>
				}
				<!--  -->
			}

			<div
				class="flex-auto overflow-hidden"
				[class.relative]="$smallScreen()"
				[class.w-full]="$smallScreen()"
				[class.h-full]="!$smallScreen()"
			>
				<!--  -->
				@switch ($selectedItem()?.previewType) {
					<!--  -->
					@case (SourcePreviewType.PDF) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<pdf-preview
								class="w-full h-full"
								[node]="file.node"
								[sources]="file.sources"
								[selectedSource]="$selectedSourceIdAsObj()"
							></pdf-preview>
						}
						<!--  -->
					}
					<!--  -->
					@case (SourcePreviewType.AUDIO) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<source-preview-with-sources
								class="w-full h-full"
								[sources]="$selectedItem()?.sources ?? []"
							>
								<audio-preview
									class="rounded-1.5 w-full bg-170"
									[node]="file.node"
								></audio-preview>
							</source-preview-with-sources>
						}
						<!--  -->
					}
					<!--  -->
					@case (SourcePreviewType.VIDEO) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<source-preview-with-sources
								class="w-full h-full"
								[sources]="$selectedItem()?.sources ?? []"
							>
								<video-preview
									class="rounded-1.5 overflow-hidden w-full bg-170"
									[node]="file.node"
								></video-preview>
							</source-preview-with-sources>
						}
						<!--  -->
					}
					<!--  -->
					@case (SourcePreviewType.IMAGE) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<image-preview
								class="rounded-1.5 overflow-hidden w-full h-full bg-170 relative"
								[file]="file.node"
							></image-preview>
						}
						<!--  -->
					}
					<!--  -->
					@default {
						<source-preview-with-sources
							class="w-full h-full"
							[sources]="$selectedItem()?.sources ?? []"
							[showContent]="false"
						></source-preview-with-sources>
					}
					<!--  -->
				}
				<!--  -->
			</div>

			@if (!$smallScreen()) {
				<div
					class="flex-none gap-1 flex scrollbar-fade overflow-auto flex-col items-start justify-start"
					[class.h-full]="!$smallScreen()"
					[style.width]="$smallScreen() ? '100%' : '280px'"
				>
					@for (item of $rightItems(); track item.node.id) {
						<ng-container
							[ngTemplateOutlet]="sourceCardTpl"
							[ngTemplateOutletContext]="{
								item: item,
								expanded: item.selected,
								withBg: item.selected,
								canToggle: false,
								inBottomMenu: false,
								selected: false,
							}"
						></ng-container>
					}
				</div>
			}
		</div>
	</div>

	@if ($smallScreen() && $showingAllSourcesMenu()) {
		<div
			class="top-0 left-0 w-full h-full flex absolute items-end justify-start backdrop-scrim"
			(click)="toggleShowingAllSourcesMenu(); $event.stopPropagation()"
		>
			<div
				class="pb-safe-b rounded-t-1.25 gap-1 w-full bg-280 shadow-z-menu flex scrollbar-fade overflow-auto relative flex-col items-start justify-start max-h-[calc(100%-64px)]"
				(click)="$event.stopPropagation()"
			>
				<div
					class="py-1.5 px-2 top-0 flex-none w-full bg-280 z-1 flex sticky items-center justify-start"
				>
					<div commonButtonIcon class="invisible">
						<i class="icon-cross-close"></i>
					</div>

					<p
						class="flex-auto truncate font-bold text-center"
						[class.text-icon]="$isDesktop()"
					>
						All used sources
					</p>

					<button
						commonButtonIcon
						(click)="toggleShowingAllSourcesMenu(); $event.stopPropagation()"
					>
						<i class="icon-cross-close"></i>
					</button>
				</div>

				@for (item of $rightItems(); track item.node.id) {
					<div
						class="px-2 flex-none w-full"
						(click)="toggleShowingAllSourcesMenu(); $event.stopPropagation()"
					>
						<ng-container
							[ngTemplateOutlet]="sourceCardTpl"
							[ngTemplateOutletContext]="{
								item: item,
								expanded: false,
								withBg: true,
								canToggle: false,
								inBottomMenu: true,
								selected: item.selected,
							}"
						></ng-container>
					</div>
				}

				<div class="flex-none w-full h-0"></div>
			</div>
		</div>
	}
</div>
